const firebase = require('firebase/app');
// require('firebase/firestore');
require('firebase/database');
require('firebase/auth');
require('firebase/storage');

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAikMRGtveNFKlmSUJ4yIsXw9_XloqvfvQ",
    authDomain: "ohana-4dd34.firebaseapp.com",
    databaseURL: "https://ohana-4dd34.firebaseio.com",
    projectId: "ohana-4dd34",
    storageBucket: "ohana-4dd34.appspot.com",
    messagingSenderId: "373526819310",
    appId: "1:373526819310:web:bab4999e026db50fb11eff"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);


// firebase utils
// const db = firebase.firestore()
const db = firebase.database()
const auth = firebase.auth()
const storage = firebase.storage()
// const currentUser = auth.currentUser

// firebase collections
const usersCollection = db.ref('Users/')
const contactsCollection = db.ref('Contacts/')
const messagesCollection = db.ref('Messages/')
const numToUidCollection = db.ref('NumberToUid/')

export {
    db,
    auth,
    storage,
    // currentUser,
    usersCollection,
    contactsCollection,
    messagesCollection,
    numToUidCollection
}


// WEBPACK FOOTER //
// ./src/tools/firebaseConfig.js